import Benefits from './Benefits';
import { BACK_TO_SCHOOL } from './constants';
import DataTreatment from './DataTreatment';
import Item from './Item';
import Requirements from './Requirements';
import Terms from './Terms';

const TyC = () => {
  return (
    <div className="flex flex-col">
      <h3 className="font-subtitle3 mb-16 w-full text-left">
        Términos y Condiciones
      </h3>
      <h3 className="font-subtitle3 w-full text-left">
        Beneficios de educación para clientes HP
      </h3>
      <h3 className="font-subtitle3 w-full text-left">
        Campaña Back to School HP
      </h3>
      <h3 className="font-subtitle3 w-full text-left">
        Organizador: Crehana (
        <a href="/" target="_blank" rel="noreferrer">
          www.crehana.com
        </a>
        ) y HP
      </h3>
      <h3 className="w-full text-left mb-16">
        <span className="font-subtitle3">Fecha de creación:</span>
        <span>9 de noviembre del 2021</span>
      </h3>

      <p className="mb-16">
        Dirigido a: toda persona física o natural interesada en aplicar al
        beneficio de un Pack con diez (10) cursos Crehana, hasta agotar
        existencias.
      </p>
      <h3 className="font-subtitle3 w-full text-left mb-16">
        La campaña Back to School tendrá como vigencia:
      </h3>
      <ul className="mb-32">
        {BACK_TO_SCHOOL.map(({ paragraph }) => (
          <Item
            paragraph={paragraph}
            key={paragraph.slice(0, 7).replace(' ', '_')}
          />
        ))}
      </ul>

      <Terms />
      <Requirements />
      <Benefits />
      <DataTreatment />

      <p className="mb-16">
        Para recibir más información o soporte del beneficio o de su redención,
        las personas pueden ponerse en contacto a través de los canales que HP
        dispone en: o en <a href="mailto:hola@crehana.com">hola@crehana.com</a>
      </p>
    </div>
  );
};

export default TyC;
